'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _effects = require('redux-saga/effects');

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _StreamLogger = require('../../../services/StreamLogger');

var _ClickTracker = require('../../../services/ClickTracker');

var _LocalizationService = require('../../../services/LocalizationService');

var _OnModuleReadyAction = require('../actions/OnModuleReadyAction');

var _OnModuleReadyAction2 = _interopRequireDefault(_OnModuleReadyAction);

var _EnterpriseEventBus = require('../../../services/EnterpriseEventBus');

var _EnterpriseEventBus2 = _interopRequireDefault(_EnterpriseEventBus);

var _Store = require('../../../services/Store');

var _Store2 = _interopRequireDefault(_Store);

var _ModuleReducer = require('../../../components/module/ModuleReducer');

var _MediaQueryService = require('../../../services/MediaQueryService');

var _QueryParameterService = require('../../../services/QueryParameterService');

var _SetModuleQueryParamsAction = require('../../../components/module/actions/SetModuleQueryParamsAction');

var _SetModuleQueryParamsAction2 = _interopRequireDefault(_SetModuleQueryParamsAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [initializeModuleSaga].map(_regenerator2.default.mark);

var isInitialized = false;

/**
 * Initializes and prepares module before first render
 * Guarded with isInitialized flag to avoid initializing twice
 */
function initializeModuleSaga() {
  var state, elementId;
  return _regenerator2.default.wrap(function initializeModuleSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          state = (0, _Store2.default)().getState().module;

          if (isInitialized) {
            _context.next = 8;
            break;
          }

          elementId = (0, _ModuleReducer.getElementId)(state);

          // ensure to send stream logger logs before window closes

          window.addEventListener('beforeunload', function () {
            (0, _StreamLogger.onWindowClosing)();
          });

          /* istanbul ignore else */
          if (_EnterpriseEventBus2.default.isInjected()) {
            // Embedded message handlers
            _EnterpriseEventBus2.default.addHandler('unload', function (event, cb) {
              var element = document.getElementById(elementId);

              /*istanbul ignore next*/
              if (element) {
                // unattach react module from DOM
                // this fires screenContainer's onWillUnmount function
                _reactDom2.default.unmountComponentAtNode(element);
              }

              // remove listeners from media query service
              (0, _MediaQueryService.unloadMediaQueryService)();

              // let host know that it is now ok to update DOM
              cb();
            });
          }

          //initialize react-intl localization
          _context.next = 7;
          return (0, _effects.call)(_LocalizationService.initLocalization);

        case 7:

          isInitialized = true;

        case 8:
          _context.next = 10;
          return (0, _effects.put)((0, _SetModuleQueryParamsAction2.default)((0, _QueryParameterService.loadQueryParameters)()));

        case 10:

          // log tracking of app ready
          (0, _ClickTracker.addAppReadyTrack)();

          // update isReady flag on store
          _context.next = 13;
          return (0, _effects.put)((0, _OnModuleReadyAction2.default)());

        case 13:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this);
}

exports.default = initializeModuleSaga;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/components/module/sagas/InitializeModuleSaga.js
// module id = 747
// module chunks = 10